import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { UserRole } from 'features/login';

const schema = z.object({
  email: z.string(),
  username: z.string(),
  groups: z.array(z.number()).min(1, 'At least one group is required'),
  role: z.nativeEnum(UserRole, {
    errorMap: () => ({ message: 'Access level is required' }),
  }),
  apps: z.array(z.string()).min(1, 'At least one app is required'),
});

export default {
  schema,
  resolver: zodResolver(schema),
};
